import { PropertyConfig } from "../../../forms/propertyConfig";
import { includes } from "../../../tools/collection.tools";
import { anyReallyAny, compare } from "../../../tools/object.tools";
import { RegisterValidator, Validator } from "./validator";
export const IS_UNIQUE_VALIDATOR = "isUnique";

/**
 * Validator params
 * uniqueProperty is the propertyName that should be unique
 * getProperties is the function that provides the array
 */
export interface isUniqueValidatorParams {
    uniqueProperty: PropertyConfig["propertyName"];
    getProperties: (allPropertiesValue: Record<string, anyReallyAny>) => anyReallyAny[];
    comparator?: (obj1: anyReallyAny, obj2: anyReallyAny) => number;
}

/**
 * This validator ensures a value is unique in given array
 * ! If value is empty/null/undefined, the validation is not applied (it is RequiredValidator's job)
 * sample use in propertyConfig => validators: validatorEntry(isUniqueValidator, array) or validators: { isUnique: array } (second option requires this class to be loaded)
 */
@RegisterValidator(IS_UNIQUE_VALIDATOR)
export class IsUniqueValidator implements Validator<anyReallyAny, isUniqueValidatorParams> {

    /**
     * @returns true if propertyValue is unique in given params
     */
    public isValid(property: PropertyConfig, propertyValue: anyReallyAny, validatorsParams: isUniqueValidatorParams,
        allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, anyReallyAny>): boolean {

        if (property.propertyName !== validatorsParams.uniqueProperty || propertyValue == null) {
            return true;
        }

        const otherProperties = validatorsParams.getProperties(allPropertiesValue);
        return !includes(otherProperties, propertyValue, (p1, p2) => {
            if (validatorsParams.comparator) {
                return validatorsParams.comparator(p1, p2) === 0;
            }
            return compare(p1, p2) === 0;
        });
    }
}